import React, { PureComponent } from 'react';
import { array, bool, func, object, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, FormSpy } from 'react-final-form';
import clsx from 'clsx';
import { FormattedMessage, intlShape, injectIntl } from '../../util/reactIntl';
import { timestampToDate } from '../../util/dates';
import { propTypes } from '../../util/types';
import { Form, IconSpinner, PrimaryButton, SecondaryButton, DangerButton } from '../../components';
import FieldDateAndTimeInput from './FieldDateAndTimeInput';
import { isEqual } from 'lodash';
import css from './RescheduleBookingTimeForm.module.css';

export class RescheduleBookingFormComponent extends PureComponent {
  constructor(props) {
    super(props);

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.state = {
      loading: false
    }
    this.submittedValues = {}
  }

  componentDidUpdate(){
    // if fetching the line items is in progress, then we set a timer to change the state aafter 750 ms
    // this means that the request is still incomplete so then we show th loading component and hide the bookingBreakdown
    // component. Else we set the state to hide the breakdown and show the loading 
    if(this.props.fetchLineItemsInProgress){
      const timer = setTimeout(() =>{
        if(this.props.fetchLineItemsInProgress){
          this.setState({
            loading: true
          });
        }
      }, 750)
      return clearTimeout(timer)
    } else {
      this.setState({
        loading: false
      });
    }
  }

  handleFormSubmit(e) {
    this.submittedValues = e
    // pass the transaction state prop in the submit function.
    e['transactionState'] = this.props.transactionState
    e['transactionRole'] = this.props.tranasctionRole
    this.props.onSubmit(e);
  }

  // When the values of the form are updated we need to fetch
  // lineItems from FTW backend for the EstimatedTransactionMaybe
  // In case you add more fields to the form, make sure you add
  // the values here to the bookingData object.
  handleOnChange(formValues) {
    const {
      bookingStartTime,
      bookingEndTime,
    } = formValues.values;
    const startDate = bookingStartTime ? timestampToDate(bookingStartTime) : null;
    const endDate = bookingEndTime ? timestampToDate(bookingEndTime) : null;
  }

  render() {
    const { rootClassName, className, publicData, ...rest } = this.props;
    const classes = clsx(rootClassName || css.root, className);

    return (
      <FinalForm
        {...rest}
        publicData={publicData}
        onSubmit={this.handleFormSubmit}
        render={fieldRenderProps => {
          const {
            endDatePlaceholder,
            startDatePlaceholder,
            form,
            pristine,
            handleSubmit,
            handleClose,
            intl,
            listingId,
            values,
            monthlyTimeSlots,
            onFetchTimeSlots,
            timeZone,
            bookingStartDate,
            bookingEndDate,
            rescheduleInProgress,
            rescheduleSaleError,
            onCloseModal,
            rescheduleBookingSuccess
          } = fieldRenderProps;
          //console.log(fieldRenderProps)

          const startTime = values && values.bookingStartTime ? values.bookingStartTime : null;
          const endTime = values && values.bookingEndTime ? values.bookingEndTime : null;

          const bookingStartLabel = intl.formatMessage({
            id: 'RescheduleBookingForm.rescheduleBookingStartDateLabel',
          });

          const bookingTimeLabel = intl.formatMessage({
            id: 'RescheduleBookingForm.rescheduleBookingStartTimeLabel',
          });

          const startDate = startTime ? timestampToDate(startTime) : null;
          const endDate = endTime ? timestampToDate(endTime) : null;

          const loadingSpinnerMaybe = this.state.loading ? (
            <IconSpinner className={css.spinner} />
          ) : null;

          const rescheduleErrorMaybe = rescheduleSaleError ? (
            <span className={css.error}>
              <FormattedMessage id="RescheduleBookingForm.reschedulingFailed" />
            </span>
          ) : null;


          const startDateInputProps = {
            label: bookingStartLabel,
            placeholderText: bookingStartDate.text,
          };
          const bookingTimeInputProps = {
            label: bookingTimeLabel
          };
         

          const dateInputProps = {
            startDateInputProps,
            bookingTimeInputProps,
          };
          const formValid = form.getState().invalid;
          const submittedOnce = Object.keys(this.submittedValues).length > 0;
          const pristineSinceLastSubmit = submittedOnce && isEqual(values, this.submittedValues);
          return (
            <Form onSubmit={handleSubmit} className={classes} enforcePagePreloadFor="CheckoutPage">
              <FormSpy
                subscription={{ values: true,  }}
                onChange={values => {
                  this.handleOnChange(values, fieldRenderProps);
                }}
              />
              {monthlyTimeSlots && timeZone ? (
                <FieldDateAndTimeInput
                  {...dateInputProps}
                  className={css.bookingDates}
                  listingId={listingId}
                  bookingStartLabel={bookingStartDate.text}
                  onFetchTimeSlots={onFetchTimeSlots}
                  monthlyTimeSlots={monthlyTimeSlots}
                  values={values}
                  intl={intl}
                  form={form}
                  pristine={pristine}
                  timeZone={timeZone}
                />
              ) : null}

              {loadingSpinnerMaybe}
              {rescheduleErrorMaybe}
              <div className={css.submitButtonWrapper}>
                <div className={css.formButtons}>
                  <PrimaryButton 
                    type="submit"
                    disabled={formValid}
                    inProgress={rescheduleInProgress}
                    ready={pristineSinceLastSubmit}
                  >
                    <FormattedMessage id="RescheduleBookingForm.rescheduleButton" />
                  </PrimaryButton>
                  <DangerButton
                    className={css.no}
                    onClick={() => {
                      form.reset();
                      onCloseModal();
                    }}
                  >
                    { rescheduleBookingSuccess
                    ? <FormattedMessage id="RescheduleBookingForm.rescheduleSuccessCloseButton" />
                    : <FormattedMessage id="RescheduleBookingForm.rescheduleCancelButton" /> }
                  </DangerButton>
                </div>
              </div>
            </Form>
          );
        }}
      />
    );
  }
}

RescheduleBookingFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  submitButtonWrapperClassName: null,
  price: null,
  isOwnListing: false,
  listingId: null,
  startDatePlaceholder: null,
  endDatePlaceholder: null,
  monthlyTimeSlots: null,
  rescheduleInProgress: false,
};

RescheduleBookingFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  submitButtonWrapperClassName: string,

  price: propTypes.money,
  isOwnListing: bool,
  listingId: propTypes.uuid,
  monthlyTimeSlots: object,
  onFetchTimeSlots: func.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,

  // for tests
  startDatePlaceholder: string,
  endDatePlaceholder: string,
};

const RescheduleBookingForm = compose(injectIntl)(RescheduleBookingFormComponent);
RescheduleBookingForm.displayName = 'RescheduleBookingForm';

export default RescheduleBookingForm;
